module.exports = __webpack_public_path__ + "img/fruit-grapes-350x184.75835862.jpg";